import { defineStore } from 'pinia'

// 后台登录态：与用户登录态（store/user）完全独立。
// 后台接口 401（后台未授权）只清本 store，绝不波及用户登录态；反之亦然。
// 两者各自管理 token、各自响应 401，互不串台。
const LS_KEY = 'crirp_admin_token'

export const useAdminStore = defineStore('admin', {
  state: () => ({
    token: localStorage.getItem(LS_KEY) || '',
  }),
  getters: {
    isLogin: (s) => !!s.token,
  },
  actions: {
    setToken(token) {
      this.token = token
      if (token) localStorage.setItem(LS_KEY, token)
      else localStorage.removeItem(LS_KEY)
    },
    // 后台接口返回 401 时被动清后台态，页面随之自动回到登录面板
    clear() {
      this.token = ''
      localStorage.removeItem(LS_KEY)
    },
  },
})
